import type { KlipyItem } from "@/lib/klipy";
import type { CommentMedia } from "@/validations/comment";

const extensionFromUrl = (url: string, fallback: "webp" | "mp4") => {
  try {
    const match = new URL(url).pathname.match(/\.([a-z0-9]+)$/i);
    return match?.[1]?.toLowerCase() ?? fallback;
  } catch {
    return fallback;
  }
};

const mimeTypeFromExtension = (extension: string) => {
  if (extension === "gif") return "image/gif";
  if (extension === "mp4") return "video/mp4";
  return "image/webp";
};

const stableHexId = (value: string) => {
  let hash = 0x811c9dc5;
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index);
    hash = Math.imul(hash, 0x01000193);
  }
  return (hash >>> 0).toString(16).padStart(12, "0");
};

export function commentMediaFromKlipy(
  item: KlipyItem,
  kind: "gif" | "sticker",
): CommentMedia | null {
  const imageUrl = item.urls.webp ?? item.urls.gif;
  const videoUrl = imageUrl ? undefined : item.urls.mp4;
  const url = imageUrl ?? videoUrl;
  if (!url) return null;

  const extension = extensionFromUrl(url, videoUrl ? "mp4" : "webp");
  const assetId = stableHexId(`${kind}:${item.slug}:${url}`);

  return {
    kind,
    width: item.width,
    height: item.height,
    asset: {
      id: `klipy-${kind}-${item.slug}`,
      key: `posts/klipy/${kind}/${assetId}.${extension}`,
      order: 0,
      provider: "klipy",
      url,
      kind: videoUrl ? "video" : "image",
      mimeType: mimeTypeFromExtension(extension),
      title: item.title,
    },
  };
}
